function MainMenu() {
    this.mainMenu = document.querySelector('.jsMainMenu');
    this.menuItemsWithChildren = this.mainMenu.querySelectorAll('li.menu-item-has-children');

    // Don't run on touch devices
    if (document.documentElement.classList.contains('touchevents')) return;

    this.menuItemsWithChildren.forEach(el => {
        const submenuEl = el.querySelector('.sub-menu');
        const menuItemEls = submenuEl.querySelectorAll('li');
        let timeline = null;
        let hover = false;

        el.addEventListener('mouseover', () => {
            if (timeline) timeline.kill();

            if (hover) return;
            hover = true;

            timeline = gsap.timeline()
                .set(submenuEl, { opacity: 0 })
                .set(menuItemEls, { opacity: 0.2 })

                .to(submenuEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' })
                .to(menuItemEls, { duration: 0.5, opacity: 1, ease: 'power2.inOut', stagger: 0.1 }, '-=0.4')

                .set([submenuEl, menuItemEls], { clearProps: 'all' })
            ;
        });

        el.addEventListener('mouseleave', () => {
            if (timeline) timeline.kill();
            hover = false;

            const submenuEl = el.querySelector('.sub-menu');

            timeline = gsap.timeline()
                .to(submenuEl, { duration: 0.5, display: 'flex', opacity: 0, ease: 'power2.inOut' })
                .set(submenuEl, { clearProps: 'all' })
            ;
        });
    });
};